import React from "react";
import "./index.css";

const ArticlePopup = ({ article, onClose }) => {
  if (!article) return null;

  return (
    <div className="article-popup-overlay" onClick={onClose}>
      <div
        className="article-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <h2>{article.title}</h2>
        <div className="article-iframe-container">
          <iframe
            src={article.link}
            title={article.title}
            width="100%"
            height="100%"
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
};

export default ArticlePopup;
